export default "__VITE_ASSET__BBHREVsj__"